import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The CourseSchedule Language",
description: "Define a simple DSL for scheduling adult training courses with teachers, rooms, and weekly time slots, and create a minimal native Freon editor to view and edit schedules.",
tags: [ "Freon", "CourseSchedule", "DSL", "scheduling", "teachers", "rooms", "TimeStamp", "modelunit", "editor", "projections", "checkbox", "fragments"] ,
modifiedTime: "2025-11-07T17:20:18.642Z",
publishedTime: "2025-11-07T17:20:18.642Z"
    }
  };
};